import { render, staticRenderFns } from "./MSDLN2025.vue?vue&type=template&id=c50d41b2&scoped=true"
import script from "./MSDLN2025.vue?vue&type=script&lang=js"
export * from "./MSDLN2025.vue?vue&type=script&lang=js"
import style0 from "./MSDLN2025.vue?vue&type=style&index=0&id=c50d41b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50d41b2",
  null
  
)

export default component.exports